import cn from 'classnames';
import styles from './DesktopDrawer.module.scss';
import { ReactNode, useRef } from 'react';
import { Backdrop } from '@/atoms/Backdrop';

type DesktopDrawerProps = {
  className?: string;
  children: ReactNode;
  onClose: () => void;
  active: boolean;
};

export function DesktopDrawer({
  className,
  onClose,
  children,
  active,
}: DesktopDrawerProps) {
  const contentClassName = cn(
    styles.content,
    {
      [styles.active]: active,
    },
    className,
  );

  const DrawerRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Backdrop visible={active} onClick={onClose} />
      <div className={contentClassName} ref={DrawerRef}>
        {children}
      </div>
    </>
  );
}
